import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {
	namespaced: true,
	state() {
		return {
			product: null,
			products: null,
			selected_products: null,
		}
	},
	mutations,
	actions,
	getters,
}
